//if comes any product that contains nfs remove it
//nfs remove start
const nfsProducts = document.querySelectorAll(`[data-product-nfs]`);
for(let elem of nfsProducts) {
    elem.remove();
}
//NFS remove end
window.Tawk_API = window.Tawk_API || {};
window.Tawk_API.onLoad = function(event){
    if(window.innerWidth < 768) {
        Tawk_API.hideWidget()
    } 
};

// scro
function ecom_scroll_to(selector) {
    const element = document.querySelector(selector);
    const elementRect = element.getBoundingClientRect();
    const elementCenterY = elementRect.top + window.scrollY + (elementRect.height / 2);
    const viewportHeight = window.innerHeight;
    
    window.scrollTo({
        top: elementCenterY - (viewportHeight / 2),
        behavior: 'smooth'
    });
}